import React from 'react'
import EnterAccountPasswordWrapper from '../../../modules/enter-account-password-modal/enter-account-password-wrapper'
import ConfirmationContent from './confirmation-content'

function Confirmation() {
  return (
    <EnterAccountPasswordWrapper>
      <ConfirmationContent />
    </EnterAccountPasswordWrapper>
  )
}

export default Confirmation
